import React from "react";
import { Paper, Typography, Divider } from "@mui/material";

const DashboardCard = ({ title, children }) => {
  return (
    <Paper
      sx={{
        p: 3,
        borderRadius: "12px",
        boxShadow: "0px 6px 16px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
      }}
    >
      {title && (
        <>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, color: "#495057" }}>
            {title}
          </Typography>
          <Divider sx={{ mb: 2 }} />
        </>
      )}
      {children}
    </Paper>
  );
};

export default DashboardCard;
